(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-sangha-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    var PIN = 'M16 0C7.163 0 0 7.163 0 16c0 10 16 28 16 28S32 26 32 16C32 7.163 24.837 0 16 0z';
    var loading;

    function loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (!loading) {
        loading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = LEAFLET_JS;
          script.async = true;
          script.onload = function () { resolve(window.L); };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      return loading;
    }

    function pinSvg(color, size) {
      return '<svg width="' + size + '" height="' + Math.round(size * 1.4) + '" viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="' + PIN + '" fill="' + color + '" stroke="rgba(0,0,0,.25)" stroke-width="1.5"/>' +
        '<circle cx="16" cy="16" r="6" fill="white"/></svg>';
    }

    function init(root) {
      var el = root.querySelector('[data-bm-sangha-map]');
      var dataEl = root.querySelector('[data-bm-sangha-data]');
      if (!el || !dataEl || el._bmSanghaMap) return;
      var entries;
      try { entries = JSON.parse(dataEl.textContent); } catch (e) { return; }

      loadLeaflet().then(function (L) {
        var styles = getComputedStyle(el);
        var templeColor = styles.getPropertyValue('--bm-sangha-temple').trim() || '#D4AF37';
        var sanghaColor = styles.getPropertyValue('--bm-sangha-sangha').trim() || '#16254c';
        var map = L.map(el, { scrollWheelZoom: false, dragging: true, zoomSnap: 0.25, zoomControl: false });
        L.control.zoom({ position: 'bottomleft' }).addTo(map);
        el._bmSanghaMap = map;
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          maxZoom: 19
        }).addTo(map);

        var points = [];
        entries.forEach(function (entry) {
          var lat = parseFloat(entry.lat);
          var lng = parseFloat(entry.lng);
          if (isNaN(lat) || isNaN(lng)) return;
          var size = entry.temple ? 32 : 26;
          var marker = L.marker([lat, lng], {
            title: entry.name,
            alt: entry.name,
            icon: L.divIcon({
              className: '',
              html: pinSvg(entry.temple ? templeColor : sanghaColor, size),
              iconSize: [size, size * 1.4],
              iconAnchor: [size / 2, size * 1.4],
              popupAnchor: [0, -size * 1.4]
            })
          });
          var tpl = root.querySelector('template[data-pop="' + entry.handle + '"]');
          if (tpl) {
            marker.bindPopup(tpl.innerHTML, {
              className: 'bm-sangha-popup',
              maxWidth: 300,
              maxHeight: Math.max(200, el.clientHeight - 70),
              autoPanPadding: [12, 12]
            });
          }
          marker.addTo(map);
          points.push([lat, lng]);
        });

        function fit() {
          if (!points.length) {
            map.setView([-29, 25], 5);
            return;
          }
          var pad = el.clientWidth < 480 ? 24 : 40;
          map.fitBounds(points, { padding: [pad, pad], maxZoom: 12 });
        }
        fit();
        map.on('resize', function () {
          if (!el.querySelector('.leaflet-popup')) fit();
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-bm-sangha]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var el = event.target.querySelector('[data-bm-sangha-map]');
      if (el && el._bmSanghaMap) el._bmSanghaMap.remove();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
